<template>
	<div class="cart">
		<FormulateForm ref="form" v-model="form" @submit="save">
			<Loader :show="loading" />
			<div class="container-fluid">
				<div class="row" >
					<div class="col-12 col-md-7 bg-grey" style="min-height:100vh">
						
						<div class="offset-md-3" style="margin-top:120px">
							<h2 class="mt-4">Finalizar compra</h2>
							<div class="section-title">
								<p class="text-white">.</p>
								<div class="label">Detalle del pedido</div>
							</div>
							<div class="mt-2 p-3">
								<div v-if="!cart || cart.products.length <= 0" class="alert alert-default">
									Aún no has agregado ningún producto al carrito de compras.
								</div>
								<div v-if="cart && cart.products.length > 0">
									<CartProductsTable :cart="cart" :editable="true" />
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-5" style="min-height:100vh">
						<div class="side-content " style="margin-top:120px">
							<div class="section-title">
								<div class="label">Datos personales</div>
								<p>Complete sus datos personales para poder finalizar su compra</p>
							</div>

							<div class="p-3 mt-1">
								<FormulateInput
									label="Nombre"
									name="name"
									ref="first"
									validation-name="Nombre"
									validation="required"
								/>

								<FormulateInput
									label="Apellido"
									name="lastname"
									validation-name="Apellido"
									validation="required"
								/>

								<FormulateInput
									label="Correo electrónico"
									name="email"
									type="email"
									validation-name="Email"
									validation="required"
								/>
								<FormulateInput
									label="Teléfono"
									type="phone"
									name="phone"
									validation-name="Teléfono"
									validation="required"
								/>
							</div>
							<div class="section-title mt-4">
								<div class="label">Datos de facturación</div>
								<p></p>
							</div>

							<div class="p-3 mt-1">
								<FormulateInput label="Razón social" name="businessName" />
								<FormulateInput label="RUT" name="businessRut" />
							</div>
							
							<div class="section-title mt-4">
								<div class="label">Forma de pago</div>
								<p></p>
							</div>

							<div class="p-3 mt-1 d-flex">
								<div @click="form.paymentMethod = 'MERCADOPAGO'" class="payment-method mercadopago" :class="{selected: form.paymentMethod == 'MERCADOPAGO'}">
									<span>
										PAGO ONLINE
									</span>
									
								</div>
								<div @click="form.paymentMethod = 'CASH'" class="payment-method cash" :class="{selected: form.paymentMethod == 'CASH'}">
									<span>
									PAGO MANUAL
									</span>
								</div>
							</div>

							<!-- <div class="section-title mt-4">
								<div class="label">Método de envío</div>
								<p>Seleccione como desea hacerse de su compra</p>
							</div>

							<div class="p-3 mt-1">
								<FormulateInput
									name="deliveryMethod"
									:options="{ OFFICE: 'Retiro en local', DELIVERY: 'Envío a domicilio' }"
									type="select"
									placeholder="Seleccione una opción"
									validation-name="Forma de envío"
									validation="required"
								/>

								<div v-if="form.deliveryMethod == 'DELIVERY'">
									<FormulateInput
										label="Agencia de envío"
										name="deliveryAgency"
										validation-name="Agencia"
										validation="required"
										help="Indique su agencia de preferencia para que le enviemos su compra"
									/>
									<FormulateInput
										label="Localidad"
										name="deliveryLocality"
										validation-name="Localidad"
										validation="required"
									/>
									<FormulateInput
										label="Dirección"
										name="deliveryAddress"
										validation-name="Dirección"
										validation="required"
									/>
									<FormulateInput
										type="textarea"
										name="deliveryComments"
										label="Comentarios"
										validation="optional|max:200,length"
										validation-name="Comentarios"
									/>
								</div>
							</div> -->
						</div>

						<div class="side-content">
							<div class="p-3 ">
								<FormulateInput type="submit" name="Finalizar compra" v-if="cart && productsValidated">
									<template>
										<div class="btn btn-primary w-100">Finalizar compra</div>
									</template>
								</FormulateInput>

								<template v-else>
									<div class="btn btn-secondary w-100 opacity-2 disabled">Finalizar compra</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>
	</div>
</template>

<script>
import gql from "graphql-tag"
import axios from "axios"
import ecommerceMixins from "./mixins"
import Loader from "@/components/Loader"
import CartProductsTable from "./CartProductsTable"

export default {
	name: "Checkout",
	mixims: [ecommerceMixins],
	components: { Loader, CartProductsTable },
	data() {
		return {
			form: {
				name: "",
				lastname: "",
				email: "",
				phone: {
					countryCode: "UY"
				},
				businessName: null,
				businessRut: null,
				deliveryMethod: null,
				deliveryAgency: null,
				deliveryLocality: null,
				deliveryAddress: null,
				deliveryComments: null,
				paymentMethod: 'MERCADOPAGO'
			},
			loading: false
		}
	},
	computed: {
		cart() {
			return this.$store.getters.cart
		},
		productsValidated() {
			let error = false
			if (this.cart.products.length <= 0) error = true
			this.cart.products.map((p) => {
				if (p.stockInsufficient) error = true
			})

			return !error
		}
	},
	methods: {
		save() {
			if (!this.loading) {
				this.loading = true

				const data = {
					client: {
						name: this.form.name,
						lastname: this.form.lastname,
						phone: this.form.phone,
						email: this.form.email,
						phone: this.form.phone
					},
					businessName: this.form.businessName,
					businessRut: this.form.businessRut,
					products: this.cart.products.map((p) => {
						return {
							product: p.product.id,
							variant: p.variant ? p.variant.id : null,
							qty: p.qty
						}
					}),
					comments: this.form.comments
				}
				
				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: OrderInput!) {
								orderCreate(data: $data) {
									id
									code
									client {
										name
										lastname
										email
										document {
											type
											number
										}
									}
								}
							}
						`,
						variables: {
							data
						}
					})
					.then(({ data }) => {
						this.emptyCart()
						if(this.form.paymentMethod == 'MERCADOPAGO'){
							this.processPayment(this.form.paymentMethod, data.orderCreate)
						}else{
							this.$router.push(`/order/${data.orderCreate.code}`)
						}
						// this.$gtag.event('orderCreated', { orderCode: data.orderCreate.code })
					})
					.catch((err) => {
						console.log(err)
						this.loading = false
					})
			}
		},
		processPayment(method, order){
			axios.post(`${process.env.VUE_APP_API_URL}/mercadopago/createPreference`, { orderId: order.id })
				.then((res) => {
					if(res.data.externalRedirectUrl){
						window.location.href = res.data.externalRedirectUrl;
					}
				})
				.catch((err) => {
					console.log(err)
				})

		}
	}
}
</script>
<style scoped lang="scss">
.cart {
	width: 100%;
}

.section-title {
	display: flex;
	justify-content: center;
	min-height: 50px;
	flex-direction: column;
}
.section-title .label {
	font-size: 18px;
	font-weight: 500;
	line-height: 18px;
}
.section-title p {
	margin: 0px;
	color: #888;
}

.side-content {
	margin: auto;
	max-width: 400px;
}

.payment-method{
	display: flex;
	flex-direction: column;
	align-items: center;
	border: rgb(216, 216, 216) solid 1px;
	border-radius: 4px;
	margin-right: 6px;
	position: relative;
	cursor: pointer;

	span{
		position: absolute;
		top: 4px;
		left: 6px;
		font-size: 12px;
		font-weight: 500;
	}
	&:after{
		margin-top: 18px;
		content: "";
		display: block;
		width: 140px;
		height: 50px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
	}
	&.mercadopago:after{
		background-image: url("~@/assets/img/icon-mercadopago.png");
	}
	&.cash:after{
		background-image: url("~@/assets/img/icon-cash.png");
	}

	&.selected{
		border: rgb(30, 100, 161) solid 2px;
	}
	&:hover{
		background-color: #f3f3f3;
	}
}
</style>
